import Constants from "../Constants";

const Certificates = () => {

   /* const loginToMerchant = async () => {
        const getLoginData = await merchantLogin();
        console.log(getLoginData);

    }*/

   /* const merchantLogin = async () => {
        let url = "https://pna.shaparak.ir/ref-payment2/RestServices/mts/merchantLogin/"
        const login = await fetch(url, {
            method: 'POST',
            mode: 'no-cors',
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json',
            },
            body: {
                "UserName": "",
                "password": ""
            }
        });
        return await login.json();
    }*/

    return (
        <section id="licenses" className="p-3 bg-primary text-center text-light">
            <div className="container">
                {/*<h1 className="font-link fw-bold pb-5 pt-5">نماد ها</h1>*/}
                <div className="d-flex justify-content-center align-content-center">


                    <div className="d-block mx-auto">
                        {/*<h5>مجوز سامانه رسانه های دیجیتال</h5>*/}
                        <img referrerPolicy="origin" id="nbqeoeukoeuksizpoeuknbqe"
                             style={{cursor: 'pointer'}}
                             onClick={() => {
                                 window.open("https://logo.samandehi.ir/Verify.aspx?id=288982&p=uiwkmcsimcsipfvlmcsiuiwk", "Popup", "toolbar=no, scrollbars=no, location=no, statusbar=no, menubar=no, resizable=0, width=450, height=630, top=30")
                             }}
                            /*onClick='window.open("https://logo.samandehi.ir/Verify.aspx?id=288982&p=uiwkmcsimcsipfvlmcsiuiwk", "Popup","toolbar=no, scrollbars=no, location=no, statusbar=no, menubar=no, resizable=0, width=450, height=630, top=30")'*/
                             alt="logo-samandehi"
                             src="https://logo.samandehi.ir/logo.aspx?id=288982&p=odrfaqgwaqgwbsiyaqgwodrf"/>
                    </div>
                    <div className="d-block mx-auto">
                        {/*<h5>اینماد</h5>*/}
                        <a referrerPolicy="origin" target="_blank"
                           href="https://trustseal.enamad.ir/?id=256766&amp;Code=hja4GeqID5FTIr8UrAtM"><img
                            referrerPolicy="origin"
                            className="img-fluid"
                            src="https://Trustseal.eNamad.ir/logo.aspx?id=256766&amp;Code=hja4GeqID5FTIr8UrAtM" alt=""
                            style={{cursor: 'pointer'}} id="hja4GeqID5FTIr8UrAtM"/></a>
                    </div>

                    {/*<div className="d-block mx-auto">
                        <h5>اینماد</h5>
                        <a referrerPolicy="origin" target="_blank"
                           href="https://trustseal.enamad.ir/?id=256766&amp;Code=hja4GeqID5FTIr8UrAtM"><img
                            referrerPolicy="origin"
                            className="img-fluid"
                            src="https://Trustseal.eNamad.ir/logo.aspx?id=256766&amp;Code=hja4GeqID5FTIr8UrAtM" alt=""
                            style={{cursor: 'pointer'}} id="hja4GeqID5FTIr8UrAtM"/></a>
                    </div>*/}

                    {/* <img
                        referrerPolicy="origin"
                        className="mx-auto w-25 h-25 img-thumbnail"
                        onClick={() => {
                            window.open('https://trustseal.enamad.ir/?id=256766&amp;Code=hja4GeqID5FTIr8UrAtM')
                        }}
                        src="https://Trustseal.eNamad.ir/logo.aspx?id=256766&amp;Code=hja4GeqID5FTIr8UrAtM" alt=""
                        style={{cursor: 'pointer'}} id="hja4GeqID5FTIr8UrAtM"/>*/}
                </div>


            </div>

            {/*<button onClick={loginToMerchant}>لاگین تراکنش</button>*/}
        </section>
    )
}

export default Certificates;